module.exports = __webpack_public_path__ + "createstatic/media/Button-realign.11e30032.svg";